function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
var humanize = function humanize(string) {
  var _string$split = string.split(/[\W\s]/g),
    _string$split2 = _toArray(_string$split),
    _string$split2$ = _toArray(_string$split2[0]),
    firstChar = _string$split2$[0],
    rest = _string$split2$.slice(1),
    words = _string$split2.slice(1);
  var capitalizedFirstWord = [firstChar.toUpperCase()].concat(_toConsumableArray(rest)).join('');
  return [capitalizedFirstWord].concat(_toConsumableArray(words)).join(' ');
};
var normalizeFieldName = function normalizeFieldName(name) {
  return name ? humanize(name) : 'Field';
};
var createErrors = function createErrors(property, value) {
  var validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var errors = [];
  _forEachInstanceProperty(validators).call(validators, function (validator) {
    var result = validator.validate(normalizeFieldName(property), value);
    if (result) {
      errors.push({
        name: validator.name,
        data: result
      });
    }
    errors[validator.name] = result;
  });
  return errors;
};
export default createErrors;